// Pushes a "navigation_filter_select" event to the dataLayer when a user clicks
// a tracked navigation item (By Need / By Persona / By Collection / By Product…).
//
// Trackable links are marked in Liquid with:
//   data-nav-type="By Need"      (the navigation group / tab label)
//   data-nav-value="Back Pain"   (the specific item label)
//
// The event carries both custom dimensions (navigation_type / navigation_value)
// and the standard GA4 params (item_list_id / item_list_name), e.g.:
//   navigation_type:  "by_need"
//   navigation_value: "back_pain"
//   item_list_id:     "by_need__back_pain"
//   item_list_name:   "By Need - Back Pain"
document.addEventListener("DOMContentLoaded", function () {
  function slug(label) {
    return (label || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
  }

  function onNavClick(e) {
    const link = e.target.closest("[data-nav-type][data-nav-value]");
    if (!link) return;

    const typeLabel = link.getAttribute("data-nav-type");
    const valueLabel = link.getAttribute("data-nav-value");
    if (!typeLabel || !valueLabel) return;

    const navigationType = slug(typeLabel);
    const navigationValue = slug(valueLabel);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "navigation_filter_select",
      navigation_type: navigationType,
      navigation_value: navigationValue,
      item_list_id: navigationType + "__" + navigationValue,
      item_list_name: typeLabel + " - " + valueLabel,
      page_path: window.location.pathname,
      full_url: window.location.origin + window.location.pathname,
      login_status: window.GTMData.login_status,
      user_id: window.GTMData.user_id,
      is_logged_user: window.GTMData.is_logged_user,
      store_country:
        window.GTMData && window.GTMData.store_country
          ? window.GTMData.store_country.toLowerCase()
          : undefined,
      store_language: window.GTMData && window.GTMData.store_language,
    });
  }

  // Only listen inside the navigation menus (desktop nav + mobile drawer),
  // not on the whole document.
  document
    .querySelectorAll(".header__menu, #MenuDrawer")
    .forEach(function (menu) {
      menu.addEventListener("click", onNavClick);
    });
});
